import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import SecureBaseStore from "./SecureBaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SavingStates from "../constants/states/SavingStates";
import {FormFieldWithValidityState} from "./FormFieldWithValidityState";


class AdvertisementEditViewState {
    constructor(
        savingState,
        title,
        description,
        imageNames,
        advertisementId,
        isEditable
    ) {
        this.savingState = savingState;
        this.title = title;
        this.description = description;
        this.imageNames = imageNames;
        this.advertisementId = advertisementId;
        this.isEditable = isEditable;
    }

    equals(other) {
        return this.savingState === other.savingState &&
            this.title.equals(other.title) &&
            this.description.equals(other.description) &&
            this.imageNames === other.imageNames &&
            this.advertisementId === other.advertisementId &&
            this.isEditable === other.isEditable;

    }
}

class ImmutableAdvertisementEditViewStateBuilder {

    constructor() {
        this.savingState = SavingStates.NOT_STARTED;
        this.title =  new FormFieldWithValidityState("", true, false);
        this.description =  new FormFieldWithValidityState("", true, false);
        this.imageNames = new FormFieldWithValidityState([], true, false);
        this.advertisementId = 0;
        this.isEditable = false;
    }

    static fromState(state) {
        return new ImmutableAdvertisementEditViewStateBuilder()
            .setSavingState(state.savingState)
            .setTitle(state.title.currentValue, state.title.isValid, state.title.isTouched)
            .setDescription(state.description.currentValue, state.description.isValid, state.description.isTouched)
            .setImageNames(state.imageNames.currentValue, state.imageNames.isValid, state.imageNames.isTouched)
            .setAdvertisementId(state.advertisementId)
            .setIsEditable(state.isEditable);
    }

    setCurrentShowImageIndex(newIndex) {
        this.currentShownImageIndex = newIndex;
        return this;
    }

    setSavingState(newState) {
        this.savingState = newState;
        return this;
    }

    setTitle(title, isValid, isTouched) {
        this.title = new FormFieldWithValidityState(title, isValid, isTouched);
        return this;
    }

    setDescription(description, isValid, isTouched) {
        this.description = new FormFieldWithValidityState(description, isValid, isTouched);
        return this;
    }

    setImageNames(imageNames, isValid, isTouched) {
        this.imageNames = new FormFieldWithValidityState(imageNames, isValid, isTouched);
        return this;
    }


    setAdvertisementId(advertisementId) {
        this.advertisementId = advertisementId;
        return this;
    }

    setIsEditable(isEditable) {
        this.isEditable = isEditable;
        return this;
    }

    build() {
        return Object.freeze(
            new AdvertisementEditViewState(
                this.savingState,
                this.title,
                this.description,
                this.imageNames,
                this.advertisementId,
                this.isEditable));
    }
}


class AdvertisementEditViewStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.ADVERTISEMENT_EDIT_VIEW_STORE_UPDATED, ImmutableAdvertisementEditViewStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_EDIT_TITLE_CHANGED, this.handleTitleChanged);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_EDIT_DESCRIPTION_CHANGED, this.handleDescriptionChanged);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_EDIT_SAVE_SUBMITTED, this.handleSaveStarted);
        this.subscribeToEvent(ActionResultEvents.ADVERTISEMENT_EDITED, this.resetStore);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_EDIT_SET_ADVERTISEMENT_ID, this.handleSetAdvertisementId);
        this.subscribeToEvent(ActionResultEvents.ADVERTISEMENT_LOADED, this.handleLoadAdvertisement)
        this.subscribeToEvent(UIInteractionEvents.DELETE_IMAGE, this.handleImageDirtyState);
        this.subscribeToEvent(ActionResultEvents.IMAGE_UPLOAD_FINISHED, this.handleImageDirtyState);
    }

    handleImageDirtyState = (topic, data) => {
        return ImmutableAdvertisementEditViewStateBuilder.fromState(this.state)
            .setImageNames(this.state.imageNames.currentValue, true, true)
            .build();
    }

    handleLoadAdvertisement = (topic, data) => {
        return ImmutableAdvertisementEditViewStateBuilder.fromState(this.state)
            .setTitle(data.title, true, false)
            .setDescription(data.description, true, false)
            .setAdvertisementId(data.advertisementId)
            .setImageNames(data.imageNames, true, false)
            .setIsEditable(data.isEditable)
            .build();
    }

    handleSetAdvertisementId = (topic, data) => {
        return ImmutableAdvertisementEditViewStateBuilder.fromState(this.state)
            .setAdvertisementId(data.advertisementId)
            .build();
    }

    handleSaveStarted = (topic, data) => {
        return ImmutableAdvertisementEditViewStateBuilder.fromState(this.state)
            .setSavingState(SavingStates.SAVING)
            .build();
    };

    handleTitleChanged = (topic, data) => {
        return ImmutableAdvertisementEditViewStateBuilder.fromState(this.state)
            .setTitle(data.title, data.isValid, true)
            .build();
    };

    handleDescriptionChanged = (topic, data) => {
        return ImmutableAdvertisementEditViewStateBuilder.fromState(this.state)
            .setDescription(data.description, data.isValid, true)
            .build();
    };

}

export default new AdvertisementEditViewStore();